export default __webpack_public_path__ + "assets/images/3e7514a9e1517c04b26b61eb271ad579.png";